function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m90.5 0h-30v362h-30v90h30v60h30v-60h30v-90h-30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m451.5 362v-362h-30v362h-30v90h30v60h30v-60h30v-90z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m331.5 0h-30v222h-30v90h30v200h30v-200h30v-90h-30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m210.5 0h-30v53.652h-30v90h30v368.348h30v-368.348h30v-90h-30z"
}));

var SvgParameterization = function SvgParameterization(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    enableBackground: "new 0 0 512 512",
    height: 31.5,
    viewBox: "0 0 512 512",
    width: 31.5,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgParameterization, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/parameterization.6553743e.svg";
export { ForwardRef as ReactComponent };